import Image from '@atoms/Image/Image';
import { IQuickLinkCard } from '@models/IQuickLinkCard';

const QuickLinkCard = ({
  link,
  image,
  dataTestId = 'QuickLinks-Card',
}: IQuickLinkCard) => (
  <a
    href={link?.url}
    target={link?.target}
    key="title"
    className="card flex h-full snap-start"
    data-testid={dataTestId}
  >
    <div className="overflow-hidden rounded-lg px-5 py-4 text-center md:px-10 md:py-12">
      <Image image={image} dataTestId={`${dataTestId}-Image`} />
      <p
        className="mt-5 text-sm md:mt-10 md:text-lg"
        data-testid={`${dataTestId}-Link-Name`}
      >
        {link?.name}
      </p>
    </div>
  </a>
);

export default QuickLinkCard;
